import { useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n/i18nContext';
import { getUrlPrefix } from '../utils/languageUtils';

export const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { language } = useI18n();

  const localizedNavigate = (to: string, options?: any) => {
    const langPrefix = '/' + getUrlPrefix(language);
    
    // If the path already has a language prefix, don't add another one
    const localizedPath = to.match(/^\/(en|ee|ru|fi)/) ? to : `${langPrefix}${to}`;
    
    navigate(localizedPath, options);
  };

  return localizedNavigate;
};